var C = {
  'getUserId': function () {
    if (window.localStorage.getItem('token')) {
      let user = window.localStorage.getItem('user')
      if (user) {
        let u = JSON.parse(user)
        return u.userId
      } else {
        return ''
      }
    }
  },
  'checkLogin': function () {
    if (window.localStorage.getItem('token')) {
      let user = window.localStorage.getItem('user')
      if (user) {
        return true
      } else {
        return false
      }
    }
  }
}
export {C}



// WEBPACK FOOTER //
// ./src/common/js/common.js